import FormField from '../../FormElements/Field';
import * as React from 'react';

export const Policy = () => (
  <FormField name="checkbox">
    <input type="checkbox" name="checkbox" required /> Az{' '}
    <a href="https://www.automatik.hu/lib/doc/adriana_adatvedelmi_tajekoztato_1.1.pdf" target="_blank" rel="noreferrer">
      adatvédelmi tájékoztatót
    </a>{' '}
    megismertem és elfogadom.
  </FormField>
);
